import { constants } from '../../../constants/constants';
import {lazyReload} from "../../../lazyReload";
const MessagePlatformPage  = lazyReload(() => import('../../../../managers/messagePlatform/MessagePlatform'));

export const MessagePlatform = [
    {path: `/${constants.pages.messagePlatformUrl}/:buildingID`, component: MessagePlatformPage, exact: true},
];
